/* PX add-to-cart - adds via /cart/add.js and keeps the shopper on the page.
   Progressive enhancement: the forms stay plain POSTs to /cart/add. If this file never
   loads, throws before the request, or the response is not the JSON we expect (network
   error, bot challenge, HTML), the native POST runs instead - add-to-cart cannot break.
   Same discipline as cart.js: parse the whole response first, then paint toast + header
   count together. Styles live in sections/px-header.liquid (#px-toast). */
(function () {
  'use strict';
  if (!window.fetch || !window.FormData || !window.DOMParser) return;

  var script = document.currentScript;
  var headerSectionId = script ? script.getAttribute('data-header-section') : '';
  var cartUrl = (script && script.getAttribute('data-cart-url')) || '/cart';
  var SUCCESS_MS = 5000;
  var ERROR_MS = 8000;
  var RESUME_MS = 3000;

  var isAddForm = function (form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.closest('product-form')) return false; /* Dawn's own component handles itself */
    var path;
    try { path = new URL(form.action, location.href).pathname; } catch (e) { return false; }
    return /\/cart\/add\/?$/.test(path);
  };

  /* The cart page paints itself from its own requests (cart.js). A native POST
     re-renders it correctly; never half-update it from here. */
  var onCartPage = function () {
    return /\/cart\/?$/.test(location.pathname);
  };

  /* ---------- toast ---------- */
  var toast = null;
  var timer = null;
  var held = false;

  var clearTimer = function () { if (timer) { clearTimeout(timer); timer = null; } };
  var dismiss = function () {
    clearTimer();
    if (!toast) return;
    var el = toast;
    toast = null;
    el.classList.remove('show');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 260);
  };
  var arm = function (ms) {
    clearTimer();
    if (held) return;
    timer = setTimeout(dismiss, ms);
  };

  var el = function (tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  var showToast = function (view) {
    if (toast && toast.parentNode) toast.parentNode.removeChild(toast);
    clearTimer();
    held = false;

    var t = el('div', 'px-toast' + (view.error ? ' is-error' : ''));
    t.id = 'px-toast';
    t.setAttribute('role', view.error ? 'alert' : 'status');
    t.setAttribute('aria-live', view.error ? 'assertive' : 'polite');

    if (view.image) {
      var img = el('img', 'px-toast-img');
      img.src = view.image;
      img.alt = '';
      img.width = 56; img.height = 56;
      t.appendChild(img);
    }

    var body = el('div', 'px-toast-body');
    body.appendChild(el('div', 'px-toast-kicker', view.kicker));
    body.appendChild(el('div', 'px-toast-title', view.title));
    if (view.meta) body.appendChild(el('div', 'px-toast-meta', view.meta));
    if (!view.error) {
      var link = el('a', 'px-toast-cta', 'View cart');
      link.href = cartUrl;
      body.appendChild(link);
    }
    t.appendChild(body);

    var close = el('button', 'px-toast-x');
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss');
    close.appendChild(el('span', null, '\u00d7'));
    close.addEventListener('click', dismiss);
    t.appendChild(close);

    var ms = view.error ? ERROR_MS : SUCCESS_MS;
    var hold = function () { held = true; clearTimer(); };
    var release = function () { held = false; arm(RESUME_MS); };
    t.addEventListener('mouseenter', hold);
    t.addEventListener('mouseleave', release);
    t.addEventListener('focusin', hold);
    t.addEventListener('focusout', release);
    t.addEventListener('touchstart', hold, { passive: true });
    t.addEventListener('touchend', release, { passive: true });
    t.addEventListener('touchcancel', release, { passive: true });

    document.body.appendChild(t);
    toast = t;
    /* next frame so the transition runs */
    (window.requestAnimationFrame || setTimeout)(function () { t.classList.add('show'); });
    arm(ms);
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && toast) dismiss();
  });

  /* ---------- response parsing (no DOM writes in here) ---------- */
  var sizedImage = function (src) {
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', '112');
      return u.toString();
    } catch (e) { return src; }
  };

  /* Header count as the server renders it: '' or ' (N)'. null = could not determine. */
  var countFromSections = function (json) {
    var html = json && json.sections && headerSectionId ? json.sections[headerSectionId] : null;
    if (!html) return null;
    var node = new DOMParser().parseFromString(html, 'text/html').getElementById('px-cart-count');
    return node ? node.textContent : null;
  };
  var countFromCart = function () {
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return null;
        return cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
      })
      .catch(function () { return null; });
  };

  var successView = function (item, qty) {
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var meta = [];
    if (variant) meta.push(variant);
    if (qty > 1) meta.push('Qty ' + qty);
    return {
      error: false,
      kicker: 'Added to cart',
      title: item.product_title || item.title || 'Item',
      meta: meta.join(' \u00b7 '),
      image: sizedImage(item.image || (item.featured_image && item.featured_image.url))
    };
  };
  var errorView = function (json) {
    /* Shopify 422: { status, message, description } - description is the shopper-facing one. */
    var msg = (json && (json.description || json.message)) || 'This item could not be added to your cart.';
    if (typeof msg !== 'string') msg = 'This item could not be added to your cart.';
    return { error: true, kicker: 'Not added', title: msg, meta: '', image: '' };
  };

  /* ---------- submit ---------- */
  var busy = typeof WeakSet === 'function' ? new WeakSet() : null;
  var setBusy = function (form, btn, on) {
    if (busy) { if (on) busy.add(form); else busy.delete(form); }
    if (!btn) return;
    if (on) {
      btn.setAttribute('data-px-label', btn.textContent);
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';
    } else if (btn.hasAttribute('data-px-label')) {
      /* If the PDP variant picker relabelled the button mid-request, its state wins. */
      if (btn.textContent === 'Adding\u2026') {
        btn.textContent = btn.getAttribute('data-px-label');
        btn.disabled = false;
      }
      btn.removeAttribute('data-px-label');
      btn.removeAttribute('aria-busy');
    }
  };

  var nativeSubmit = function (form) {
    /* HTMLFormElement.submit() does not fire 'submit', so this cannot re-enter. */
    HTMLFormElement.prototype.submit.call(form);
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !isAddForm(form) || onCartPage()) return;
    if (busy && busy.has(form)) { e.preventDefault(); return; }

    var body, qty, btn;
    try {
      btn = e.submitter || form.querySelector('[type="submit"]');
      body = new FormData(form);
      if (!body.get('id')) return; /* nothing to add via AJAX - let the native POST speak */
      qty = parseInt(body.get('quantity'), 10);
      if (!(qty > 0)) qty = 1;
      if (headerSectionId) {
        body.append('sections', headerSectionId);
        body.append('sections_url', location.pathname);
      }
    } catch (err) {
      return; /* not prevented yet -> native POST */
    }

    e.preventDefault();
    setBusy(form, btn, true);

    /* Once the server has answered in a shape we recognise (a line item, or a 422 refusal)
       the add is settled; from then on nothing may re-POST the form, whatever else goes wrong. */
    var answered = false;

    fetch(form.action.replace(/\/?$/, '') + '.js', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        /* Shopify serves /cart/add.js as text/javascript, so the content-type says nothing.
           Parse the body; the shape check below is what accepts or rejects it. */
        return res.text().then(function (txt) {
          var json;
          try { json = JSON.parse(txt); } catch (e) {
            throw new Error('unparseable response ' + res.status + ' (' + (res.headers.get('content-type') || '?') + ')');
          }
          return { ok: res.ok, status: res.status, json: json };
        });
      })
      .then(function (r) {
        if (!r.ok || (r.json && r.json.status && r.json.message)) {
          answered = true;
          return { view: errorView(r.json), count: null };
        }
        var item = r.json && r.json.items ? r.json.items[0] : r.json;
        if (!item || !(item.variant_id || item.id)) throw new Error('unexpected add.js shape (' + r.status + ')');
        answered = true;
        var view = successView(item, qty);
        var count = countFromSections(r.json);
        if (count !== null) return { view: view, count: count };
        return countFromCart().then(function (c) { return { view: view, count: c }; });
      })
      .then(function (out) {
        /* everything is parsed - paint together */
        var countEl = document.getElementById('px-cart-count');
        if (countEl && out.count !== null) countEl.textContent = out.count;
        showToast(out.view);
        setBusy(form, btn, false);
      })
      .catch(function (err) {
        setBusy(form, btn, false);
        if (answered) {
          /* The cart already changed. Say so plainly rather than re-adding. */
          if (window.console) console.error('px-atc: add settled but the update failed -', err);
          try { showToast({ error: false, kicker: 'Added to cart', title: 'Item added', meta: '', image: '' }); } catch (e2) {}
          return;
        }
        /* Network failure, bot challenge, HTML, unknown shape: hand over to the native POST. */
        if (window.console) console.warn('px-atc: falling back to the native POST -', err);
        nativeSubmit(form);
      });
  });

  /* Back-forward cache can restore a page mid-"Adding..." after a native fallback. */
  addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-px-label]').forEach(function (btn) {
      setBusy(btn.form, btn, false);
    });
  });
})();
